// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SXlv","clinicsSelect":"styles_clinicsSelect__3z_OC"};